import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { ChangeDetectionStrategy } from '@angular/core';
import { EscolaridadService } from '../../services/escolaridad/escolaridad.service';
import { ProductosService } from 'src/app/services/productos/productos.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { PostulacionesService } from 'src/app/services/postulaciones/postulaciones.service';
import { AfiliacionService } from 'src/app/services/afiliacion/afiliacion.service';
import Swal from 'sweetalert2';
import { environment } from '../../../environments/environment';

declare const Rut: any;
declare const ageCalculator: any;

export interface DialogData {
  rut: any,
  dv: any,
  motivo: string,
  fechaRechazo: any
}

@Component({
  selector: 'app-rechazar-solicitud-afiliacion',
  templateUrl: '../../pages/afiliacion/dialog-rechazar-solicitud-afiliacion.component.html',
  styleUrls: ['../../pages/solicitud-afiliacion/solicitud-afiliacion.component.css'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class DialogRechazarSolicitudAfiliacionComponent implements OnInit, OnDestroy {

  nombreUsuario: string = localStorage.getItem("nombreUsuario")
  rutAfiliado: string = localStorage.getItem("rutAfiliado")
  idEjecutivo = localStorage.getItem("idUsuario")
  rutUsuario: any;
  fechaRechazo: any;
  motivo: string;
  rut: any;
  mostrarDatosCargados: boolean;
  cursos: any[]; postulantes: any[];
  afiliado: any = { rut: "", sub: "", name: "", nombres: "", idAfiliado: '', email: '', nombreAfiliado: '', apellidoAfiliado: '' };

  constructor(private router: Router,
    public dialogRef: MatDialogRef<DialogRechazarSolicitudAfiliacionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData, private dialog: MatDialog,
    private postulacionesService: PostulacionesService, private afiliacionService: AfiliacionService) {
    let vm = this

  }

  ngOnInit(): void {
  }


  ngOnDestroy(): void {
  }



  casoExitoso() {
    this.router.navigate(['/login'])
  }
  casoFallido() {
    this.router.navigate(['/solicitud-afiliacion'])
  }


  onRechazarSolicitud(form: NgForm) {
    let vm = this;

    const dialogRef = this.dialog.open(ConfirmationDialog,
      {
        data: { message: '¿Esta seguro rechazar la solicitud de afiliación?', buttonText: { ok: 'Si', cancel: 'No' } }
      })
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        Swal.fire({
          allowOutsideClick: false,
          icon: 'info',
          text: 'Cargando...'
        });
        Swal.showLoading();


        if (!form.form.value.fechaRechazo) {
          this.openAlertDialog('Debe ingresar la fecha de rechazo', 'btn-danger')
          Swal.close();
          return false
        }

        if (!form.form.value.motivo) {
          this.openAlertDialog('Debe ingresar el motivo de rechazo', 'btn-danger')
          Swal.close();
          return false
        }

        this.afiliacionService.rechazarSolicitud(vm.data.rut, form.form.value.fechaRechazo, form.form.value.motivo, vm.idEjecutivo).then
          (
            response => {
              //    vm.openAlertDialog('Se ha rechazado la solicitud al afiliado.', 'btn-success')
              Swal.close();
              this.dialogRef.close()
            }
          )
          .catch
          (
            () => {
              Swal.close();
            }
          )
      }
    })

  }

  openAlertDialog(mensaje: string, clase: string) {
    this.dialog.open(AlertDialogComponent, {
      data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
    })
  }

  onCancelarClick(): void { this.dialogRef.close() }
}
